<template>
  <div class="ganPin-analysis-page">
    <el-tabs v-model="agriculture" @tab-click="handleClick">
      <el-tab-pane label="鄱阳湖银鱼" name="鄱阳湖银鱼">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way"  @change="getWholeList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3"  style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.sMonth" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.eMonth" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="options" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="wholeTable" height="340" stripe class="float-left border-DEDEDE colorChang margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
        <el-row class="margin-l-30 margin-r-30 margin-b-20">
          <el-col :span="8" class="padding-r-20">
            <el-card style="height: 473px">
              <chart ref="chart1" :options="platformComOptions" autoresize class="width-z100"></chart>
            </el-card>
          </el-col>
          <el-col :span="8" class="padding-r-20">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">企业店铺排行</span>
              </div>
              <el-table :data="companyTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">个人店铺排行</span>
              </div>
              <el-table :data="personalTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="庐山云雾茶" name="庐山云雾茶">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way" @change="getWholeList()">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3"  style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.sMonth" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.eMonth" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="options" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="wholeTable" height="340" stripe class="float-left border-DEDEDE colorChang margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
        <el-row class="margin-l-30 margin-r-30 margin-b-20">
          <el-col :span="8" class="padding-r-20">
            <el-card style="height: 473px">
              <chart ref="chart1" :options="platformComOptions" autoresize class="width-z100 "></chart>
            </el-card>
          </el-col>
          <el-col :span="8" class="padding-r-20">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">企业店铺排行</span>
              </div>
              <el-table :data="companyTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">个人店铺排行</span>
              </div>
              <el-table :data="personalTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>

      </el-tab-pane>
      <el-tab-pane label="宁红茶" name="宁红茶">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way" @change="getWholeList()">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3"  style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.sMonth" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.eMonth" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="options" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="wholeTable" height="340" stripe class="float-left border-DEDEDE colorChang margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
        <el-row class="margin-l-30 margin-r-30 margin-b-20">
          <el-col :span="8" class="padding-r-20">
            <el-card style="height: 473px">
              <chart ref="chart1" :options="platformComOptions" autoresize class="width-z100 "></chart>
            </el-card>
          </el-col>
          <el-col :span="8" class="padding-r-20">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">企业店铺排行</span>
              </div>
              <el-table :data="companyTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">个人店铺排行</span>
              </div>
              <el-table :data="personalTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>

      </el-tab-pane>
      <el-tab-pane label="九江茶饼" name="九江茶饼">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way" @change="getWholeList()">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3"  style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.sMonth" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.eMonth" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="options" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="wholeTable" height="340" stripe class="float-left border-DEDEDE colorChang margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
        <el-row class="margin-l-30 margin-r-30 margin-b-20">
          <el-col :span="8" class="padding-r-20">
            <el-card style="height: 473px">
              <chart ref="chart1" :options="platformComOptions" autoresize class="width-z100 "></chart>
            </el-card>
          </el-col>
          <el-col :span="8" class="padding-r-20">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">企业店铺排行</span>
              </div>
              <el-table :data="companyTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">个人店铺排行</span>
              </div>
              <el-table :data="personalTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>

      </el-tab-pane>
      <el-tab-pane label="瑞昌山药" name="瑞昌山药">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way" @change="getWholeList()">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3"  style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.sMonth" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.eMonth" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="options" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="wholeTable" height="340" stripe class="float-left border-DEDEDE colorChang margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
        <el-row class="margin-l-30 margin-r-30 margin-b-20">
          <el-col :span="8" class="padding-r-20">
            <el-card style="height: 473px">
              <chart ref="chart1" :options="platformComOptions" autoresize class="width-z100"></chart>
            </el-card>
          </el-col>
          <el-col :span="8" class="padding-r-20">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">企业店铺排行</span>
              </div>
              <el-table :data="companyTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div slot="header" class="index-header text-left">
                <span class="index-header-title">个人店铺排行</span>
              </div>
              <el-table :data="personalTopTable" stripe width="480px" height="373px" class="border-DEDEDE"
                        :default-sort="{prop: 'money', order: 'descending'}">
                <el-table-column type="index" label="排名" width="50"></el-table-column>
                <el-table-column prop="shop" label="商铺名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.url"
                       target="_blank"
                       class="buttonText text-666">{{scope.row.shop}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="销售额（元）" width="150" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>

      </el-tab-pane>
    </el-tabs>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">注：<BR/>
      1.特色产品是指九江市当地较为知名且具有地方特色的产品<br/>
      2.特色产品网络零售额是指全国范围内销售九江市特色产品的网络零售额</p>
  </div>
</template>

<script>
  export default {
    name: 'ganPin-analysis',
    data () {
      return {
        agriculture: '鄱阳湖银鱼',
        options: {}, //整体情况图表
        form: {},
        wholeTitle: '',
        wholeList: {xTime: [], yTotalmoney: [], simple: []},
        wholeTable: [],
        wholeForm: { sMonth: '', eMonth: '', category: '鄱阳湖银鱼',way:'当期网络零售额'},//整体情况筛选条件
        wholeTime: '1',
        cityOptions: {},//地区类型柱图
        cityCategory: [],//赣品分地区筛选类型
        platformComOptions:{},//地区选择模块平台占比图表
        companyTopTable:[],//赣品企业店铺排行榜
        personalTopTable:[],//赣品个人店铺排行
        cityType:'',
        districtType:'',
        cityTable: [],
        cityTime: '1',
        cityList: [],
        areaList: [],
        cityTitle: '',
        cityForm: {way: '1', area: '1', startTime: '', endTime: ''},//地区类型筛选条件
        cityChoose: [{
          id: 1,
          name: '南昌市',
          children: [{id: 1, name: '青山湖区'}, {id: 2, name: '东湖区'}, {id: 3, name: '西湖区'}, {id: 4, name: '南昌县'}, {
            id: 5,
            name: '青云谱区'
          }, {id: 6, name: '新建区'}, {id: 7, name: '进贤县'}, {id: 8, name: '湾里区'}, {id: 9, name: '安义县'}]
        },
          {id: 2, name: '九江'}, {id: 3, name: '景德镇'}, {id: 4, name: '上饶'},
          {id: 5, name: '鹰潭', children: [{id: 1, name: '贵溪市'}]}, {id: 6, name: '宜春'}, {id: 7, name: '萍乡'}, {
            id: 8,
            name: '新余'
          }, {id: 9, name: '抚州'}, {id: 10, name: '吉安'}, {id: 11, name: '赣州'}],
        productTime: '1',
        productForm: {way: '1', endTime: ''}, //商品大类筛选条件
        transactionTime: '1',
        transactionTitle: '',
        transactionForm: {way: '1', resource: '1', startTime: '', endTime: '', platform: '全部'},//交易平台筛选条件
        regionDis: true,
        //表格数据

        productTwoTable: [],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.twelveMonth()
      // this.oneMonth()
    },
    methods: {
      //切换赣品
      handleClick(tab, event) {
        this.wholeForm.category = tab.name
        this.getWholeList()
      },
      //赣品情况列表
      getWholeList () {
        this.$http.get(this.header + '/featured/info', {
          params: {
            index_type: this.wholeForm.way,
            sMonth: this.wholeForm.sMonth,
            eMonth: this.wholeForm.eMonth,
            category: this.wholeForm.category
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.wholeTable = []
            this.wholeList = {xTime: [], yTotalMoney: [], simple: []}

            this.companyTopTable = res.data.companyShopRank
            this.personalTopTable = res.data.personalShopRank
            res.data.sales.reverse().forEach((y, index) => {
              this.wholeList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '元'
              }

              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              if(y.absoulte_value_yoy == null){
                y.absoulte_value_yoy = '--'
              }
              this.wholeTable.push(y)
              this.wholeList.yTotalMoney.push(yMoney)
              // this.wholeList.yTotalMoney.unit.push('万元')
              this.wholeList.simple.push(xSimple)
            })
            let Min1 = this.calMin(this.wholeList.yTotalMoney), Min2 = this.calMin(this.wholeList.simple),
              Max1 = this.calMax(this.wholeList.yTotalMoney), Max2 = this.calMax(this.wholeList.simple)
            //整体情况图标
            this.options = {
              title: {//图表标题
                text: '赣品' + this.wholeForm.category + '变化趋势',
                left: 'center',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              toolbox: { //图表工具箱
                feature: {
                  magicType: {show: true, type: ['line', 'bar']},
                  restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function (e) {
                  return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                }
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['销售额', '同比']
              },
              xAxis: {
                type: 'category',
                data: this.wholeList.xTime.reverse(),
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '元',
                  min: Min1,
                  max: Max1,
                  splitNumber: 5,
                  interval: (Max1 - Min1) / 5,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                }, {
                  type: 'value',
                  name: '%',
                  min: Min2,
                  max: Max2,
                  splitNumber: 5,
                  interval: (Max2 - Min2) / 5,
                  axisLabel: {
                    formatter: '{value} %'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                }],
              series: [{
                name: '销售额',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: '#7888ed'
                  },
                  emphasis: {
                    color: '#83bff6'
                  }
                },
                data: this.wholeList.yTotalMoney.reverse(),
                smooth: true
              }, {
                name: '同比',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#FB975B'
                  }
                },
                data: this.wholeList.simple.reverse()
              }]
            }
            //平台占比
            let platformList = {xLegend: [], yCom: []}
            res.data.platform.forEach((y, index) => {
              platformList.xLegend.push(y.paltform)
              let yMoney = {
                value: y.sales,
                name: y.paltform
              }
              platformList.yCom.push(yMoney)
            })
            this.platformComOptions = {
              title: {
                text: '电商平台'+this.wholeForm.way+'占比',
                x: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  bottom: 10,
                },
              },

              tooltip: {
                trigger: 'item',
                formatter: '{b}占比 : {d}%'
              },
              legend: {
                x: 'center',
                y: 'bottom',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: platformList.xLegend
              },
              calculable: true,
              series: [
                {
                  name: '半径模式',
                  type: 'pie',
                  radius: ['45%', '60%'],
                  center: ['50%', '50%'],
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold',
                      }
                      // formatter: "{a} <br/>{b}: {c} ({d}%)"
                    }
                  },
                  lableLine: {
                    normal: {
                      show: false
                    },
                    emphasis: {
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        let colorList = ['#71CBC0', '#85B0FB', '#F7AE4E', '#FFC4C6', '#4C8DFF', '#FF9F7F', '#FFDB5C', '#67E0E3', '#9FE6B8', '#32C5E9']
                        //  var colorList = ['red','blue'];
                        return colorList[params.dataIndex % 10]
                      }
                    },

                  },
                  data: platformList.yCom
                }
              ]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },

      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (let i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          let m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.wholeTime = '1'
        if ( day > 14) {
          this.wholeForm.sMonth = dataArr[13]
          this.wholeForm.eMonth = dataArr[1]
        } else {
          this.wholeForm.sMonth = dataArr[14]
          this.wholeForm.eMonth = dataArr[2]
        }
        this.getWholeList()

      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
      //计算最大值
      cityCalMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      cityCalMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
    }
  }
</script>

<style>

  .ganPin-analysis-page .el-tabs__nav-wrap {
    box-shadow: 5px 0px 15px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(100, 156, 238, 0.4);
    /*background-color: #323740;*/
  }

  .ganPin-analysis-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .ganPin-analysis-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .ganPin-analysis-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .ganPin-analysis-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .ganPin-analysis-page .el-form-item {
    margin-bottom: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/ganPinMonitoring/ganPin-analysis.vue